import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoading: false,
  token: null,
  user: null,
});

const reducer = handleActions(
  {
    [types.SET_LOADING]: (state, { payload }) =>
      state.set("isLoading", payload),
    [types.SET_USER]: (state, { payload }) => state.set("user", payload),
    [types.SET_TOKEN]: (state, { payload }) => state.set("token", payload),
    [types.AUTH]: (state) => state.set("isLoading", true),
    [types.AUTH_FAIL]: (state) => state.set("isLoading", false),
    [types.AUTH_SUCCESS]: (state, { payload: response }) =>
      state
        .set("isLoading", false)
        .set("token", response.data.token)
        .set("user", response.data.user),
    [types.RENEW_FAIL]: (state) =>
      state.set("isLoading", false).set("token", null).set("user", null),
  },
  INITIAL_STATE
);

export default reducer;
